export enum DateOption {
  Today = "Today",
  PastWeek = "Last 7 days",
  PastMonth = "Last 30 days",
  PastTwoMonths = "Last 60 days",
  PastQuarter = "Last 90 days",
  PastFourMonths = "Last 120 days",
  Custom = "Custom",
}
